//import Vue from "vue";
import axios from "axios";


const client = axios.create({
  baseURL: "https://axpstg.axesspoint.app/api/caliber",
  json: true,
}); 

var arrStructures = [];



export default {
  async execute(method, resource, data) {
    console.log("calling resource" + resource);
    // inject the accessToken for each request
    //let accessToken = await Vue.prototype.$auth.getAccessToken();
    return client({
      method,
      url: resource,
      data,
      /*headers: {
        Authorization: `Bearer ${accessToken}`,
      },*/
    }).then(req => {
      console.log(req);
      return req.data;
    });
  },
  getPosts() {
    return this.execute("get", "/posts");
  },
  getPost(id) {
    return this.execute("get", `/posts/${id}`);
  },
  createPost(data) {
    return this.execute("post", "/posts", data);
  },
  updatePost(id, data) {
    return this.execute("put", `/posts/${id}`, data);
  },
  deletePost(id) {
    return this.execute("delete", `/posts/${id}`);
  },
  getStructures() {
    return [
      {
        id: 1,
        name: "Tower A",
      },
      {
        id: 2,
        name: "Tower B",
      },
    ];
    //return this.execute('get', '/posts')
  },
  getStructure(intStructureId) {
    const objStructure = arrStructures.find(obj => (obj.id == intStructureId));
    return objStructure;
  },
  getLevels(intStructureId) {
    const objStructure = arrStructures.find(obj => obj.id == intStructureId);
    if (objStructure) {
      return objStructure.arrLevels;
    }
    return [];
  },
  getLevel(intLevelId) {
    for (let objStructure of arrStructures) {
      for (let objLevel of objStructure.arrLevels) {
        if (objLevel.id == intLevelId) {
          return objLevel;
        }
      }
    }
    return null;
  },
  getParkingStalls() {
    let arrParkingStalls = [];
    for (let objStructure of arrStructures) {
      let strStructureName = objStructure.name;
      for (let objLevel of objStructure.arrLevels) {
        let strLevelName = objLevel.name;
        for (let objStall of objLevel.arrStalls) {
          let strStallName = objStall.name;
          let str = strStructureName + "-" + strLevelName + "-" + strStallName;
          arrParkingStalls.push(str);
        }
      }
    }
    return arrParkingStalls;
  },
  getContracts() {
    let arr = [
      {
        id: 1,
        renter_name: "Bank of America",
        cell_phone: "808 202 2939",
        employer_name: "n/a",
        work_phone: "808 238 1231",
        email: "carl@boa.com",
        employer_address: "Bank of America, Honolulu etc",
        valid_from:"11-19-2019",
        valid_till:"12-19-2019",
        status:"Active",
        arrStallVehicles: [
          {
            id: 1,
            license_plate: "HQW 9182",
            vehicle_year: "2017",
            vehicle_make: "TOYOTA",
            vehicle_model: "COROLLA",
            vehicle_height: "",
            vehicle_width: "",
            vehicle_length: "",
            stall: "A:A1:1",
          },
          {
            id: 2,
            license_plate: "HQW 9182",
            vehicle_year: "2017",
            vehicle_make: "TOYOTA",
            vehicle_model: "COROLLA",
            vehicle_height: "",
            vehicle_width: "",
            vehicle_length: "",
            stall: "A:A1:2",
          },
          {
            id: 3,
            license_plate: "HQW 9182",
            vehicle_year: "2017",
            vehicle_make: "TOYOTA",
            vehicle_model: "COROLLA",
            vehicle_height: "",
            vehicle_width: "",
            vehicle_length: "",
            stall: "A:A1:3",
          },
        ],
      }, {
        id: 4,
        renter_name: "BELLO SILITSHINA",
        cell_phone: "808 123 1339",
        employer_name: "AxessPoint",
        work_phone: "808 331 1233",
        email: "bello@axesspoint.app",
        employer_address: "AXESSPOINT, Honolulu etc",
        valid_from:"11-11-2019",
        valid_till:"12-11-2019",
        status:"Active",
        arrStallVehicles: [
          {
            id: 5,
            license_plate: "AXP 1234",
            vehicle_year: "2017",
            vehicle_make: "HONDA",
            vehicle_model: "ACCORD",
            vehicle_height: "",
            vehicle_width: "",
            vehicle_length: "",
            stall: "A:A2:14",
          },
          
        ],
      }, {
        id: 5,
        renter_name: "MIKE HARDING",
        cell_phone: "808 421 1234",
        employer_name: "AxessPoint",
        work_phone: "808 331 1233",
        email: "mike@axesspoint.app",
        employer_address: "AXESSPOINT, Honolulu etc",
        valid_from:"10-11-2019",
        valid_till:"10-11-2019",
        status:"Expired",
        arrStallVehicles: [
          {
            id: 5,
            license_plate: "AXP 6666",
            vehicle_year: "2018",
            vehicle_make: "BMW",
            vehicle_model: "X5",
            vehicle_height: "",
            vehicle_width: "",
            vehicle_length: "",
            stall: "B:B4:15",
          },
          
        ],
      },
    ];

    return arr;
  },async getUnits(){
    
     
    //var obj= await this.execute("get", `/units?mode=live`);
    var obj= await this.execute("get", `/units`);

    return obj;

  },async getUnitAccounts(intId){
    
     
    var obj= await this.execute("get", `/units/${intId}/accounts`);
    return obj;

  },async getUnitAccountTransactions(intId){
    
     
    var obj= await this.execute("get", `unit-accounts/${intId}/transactions`);
    return obj;

  }
};
